// src/services/forms/moiteBaranja.js

export const MoiteBaranjaColumns = [
    { name: "baratel", label: "Барател", field: "baratel", align: "left" },
    { name: "aplikacija", label: "Апликација", field: "aplikacija", align: "left" },
    { name: "opis", label: "Опис", field: "opis", align: "left" },
    { name: "stepen", label: "Степен итност", field: "stepen", align: "center" },
    { name: "edit", label: "Уреди", field: "edit", align: "center" },
    { name: "delete", label: "Избриши", field: "delete", align: "center" },
  ];
  
  export const MoiteBaranjaFileColumns = [
    { name: "preview", label: "", align: "center" },
    { name: "FileName", label: "Име на фајл", field: "FileName", align: "left" },
    {
      name: "size",
      label: "Големина (KB)",
      field: "sizeKB",
      align: "center",
      format: (val) => (val != null ? val.toFixed(1) : ""),
    },
    { name: "actions", label: "Акции", align: "center" },
  ];